import React from 'react';
import { withTheme } from 'styled-components';
import { Popover, MaterialIcon, SVGIcon } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import messages from './messages';
import { Header,
  HeaderTitle,
  Container,
  MessageLine,
  CloseButton,
  WarningIconContainer,
} from './styles';

const KnowledgeMapWarningPopover = (props) => {
  const {theme, onClose} = props;
  const iconType = 'warningCircle';
  return (
    <Popover {...props}>
      <Container>
        <Header>
          <WarningIconContainer>
            <SVGIcon size="medium" icon={iconType} fill={theme['color.redDark']} />
          </WarningIconContainer>
          <HeaderTitle>{intl.formatMessage(messages.warningTitle)}</HeaderTitle>
        </Header>
        <MessageLine>{intl.formatMessage(messages.warningMessage)}</MessageLine>
        <CloseButton grey iconOnly onClick={onClose}>
          <MaterialIcon id="close" />
        </CloseButton>
      </Container>
    </Popover>
  );
};

export default withTheme(KnowledgeMapWarningPopover);
